import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

type SnackType = 'success' | 'error' | 'info';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private queue: Array<{ message: string; type: SnackType }> = [];
  private isShowing = false;

  constructor(private readonly snackBar: MatSnackBar) { }

  showSuccess(message: string) { this.enqueue(message, 'success'); }
  showError(message: string) { this.enqueue(message, 'error'); }
  showInfo(message: string) { this.enqueue(message, 'info'); }

  // -------------------------
  //   COLA DE SNACKBARS
  // -------------------------
  private enqueue(message: string, type: SnackType) {
    this.queue.push({ message, type });
    if (!this.isShowing) {
      this.processQueue();
    }
  }

  private processQueue() {
    if (this.queue.length === 0) {
      this.isShowing = false;
      return;
    }

    this.isShowing = true;
    const { message, type } = this.queue.shift()!;

    const panelClass = `${type}-snackbar`; // success-snackbar | error-snackbar | info-snackbar

    const ref = this.snackBar.open(message, 'Cerrar', {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
      panelClass: [panelClass, 'custom-app-snackbar']
    });

    ref.afterDismissed().subscribe(() => {
      this.isShowing = false;
      setTimeout(() => {
        this.processQueue();
      }, 50);
    });
  }
}
